import { NoticeBubbleContainer } from '@semcore/ui/notice-bubble';

import noticeManager from '../lib/noticeManager';

export default function NoticeContainer() {
  return <NoticeBubbleContainer manager={noticeManager} />;
}
